import { render, staticRenderFns } from "./PDFviewer.vue?vue&type=template&id=1b2c7f14"
import script from "./PDFviewer.vue?vue&type=script&lang=js"
export * from "./PDFviewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports